/* storybook-check-ignore */
import { Box, BoxProps, Text } from '@opendoor/bricks/core';

function ObfuscatedAddressNotification({
  isVisible,
  ...boxProps
}: { isVisible: boolean } & BoxProps) {
  if (!isVisible) return null;
  return (
    <Box padding="0.5rem" borderY="1px solid" borderColor="neutrals100" {...boxProps}>
      <Text fontWeight="regular" fontSize="s0" lineHeight="s00">
        Exact address will be revealed when it's available.
      </Text>
    </Box>
  );
}

export default ObfuscatedAddressNotification;
